import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { InstantSearch, Configure } from 'react-instantsearch';
import { searchClient } from 'components/essentials/AlgoliaSearchClient';
import CatchAlgoliaSearchError from 'components/essentials/CatchAlgoliaSearchError';
import { ReviewSearchOptions, ReviewSearchBox } from '../utils';
const ReviewSearch = props => {
  const $ = _c(11);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CatchAlgoliaSearchError />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = props.searchQuery ? props.searchQuery : "";
  let t2;
  if ($[1] !== t1) {
    t2 = <Configure query={t1} hitsPerPage={5} />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props.onSearchUpdate) {
    t3 = <ReviewSearchBox onSearchUpdate={props.onSearchUpdate} />;
    $[3] = props.onSearchUpdate;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props) {
    t4 = <ReviewSearchOptions {...props} />;
    $[5] = props;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = <div className="relative"><InstantSearch searchClient={searchClient} indexName="reviews">{t0}{t2}{t3}{t4}</InstantSearch></div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
ReviewSearch.propTypes = {
  searchQuery: PropTypes.string,
  onSearchUpdate: PropTypes.func
};
export default ReviewSearch;